<template>
    <div class="verification">
      <div class="login" v-if="goodsList.length<=0">
            <!-- 欢迎登录 -->

          <div class="welcome font64 c333">
            <div>团购核销</div>
            <div class="decoration"></div>
          </div>
          <!-- 欢迎登录end -->
          <!-- 输入账户名密码 -->
          <div class="user">
            <div class="username">
              <input type="number" class="userinput" v-model="code" maxlength="6" placeholder="请输入核销码">
            </div>
          </div>
          <!-- 输入账户名密码end -->
          <!-- 登录按钮 -->
          <div class="successbtn btncolor loginbtn" @click="verification()">提货</div>
      </div>

      <div class="goodsList" v-if="goodsList.length>0">
        <van-card v-for="item in goodsList" v-bind:key="item.index" class="mb20" :num="item.quantity" :price="item.goodsPrice" :title="item.goodsName" :thumb="item.coverImgUrl">
            <template #tags>
              <van-tag v-for="label in item.label" v-bind:key="label.index" class="mt20 mr10" plain type="danger">{{label}}</van-tag>
            </template>
        </van-card>
      </div>
    </div>

</template>

<script>
// import Tabbar from '../components/tabbar.vue'
import { Notify, Toast } from 'vant'

// import { Checkbox, CheckboxGroup } from 'vant'
export default{
  name: 'verification', // 个人中心
  components: {
    // 'Tabbar': Tabbar
  },

  data () {
    return {
      code: '',
      goodsList: []
    }
  },
  created () {

  },
  mounted () {

  },

  methods: {

    // 请求数据

    verification () {
      var that = this
      if (this.code) {
        var Pickcode = Number(that.code)
        Toast.loading({
          message: '提货中...',
          forbidClick: true,
          duration: 0
        })
        this.$api.HZrequest('/we-chat/gzh/groupOrder/selfCode/check', 'POST', {'code': Pickcode}).then((res) => {
          if (res.code == 200) {
            setTimeout(function () {
              that.goodsList = res.data
              Toast.clear()
            }, 300)
          } else {
            this.errCode()
          }
        })
      } else {
        this.errCode()
      }
    },

    errCode () {
      Toast.clear()
      Notify({
        type: 'primary',
        message: '请输入正确提货码'
      })
    }

  }

}
</script>

<style>
.login {
    box-sizing: border-box;
    padding: 0 0.32rem;
    padding-top: 1.4rem;
    background: #fff;
    min-height: 100%;
    position: fixed;
    width: 100%;
  }

  .welcome {
    position: relative;
    font-weight: bold;
  }

  .decoration {
    width: 1.24rem;
    height: 0.08rem;
    background: rgba(255, 209, 0, 0.6);
    position: absolute;
    bottom: 0.3rem;
    left: 1.3rem;
  }

  .user {
    width: 100%;
    margin-top: 1rem;
  }

  .username {
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    height: 0.8rem;
    position: relative;
  }

  .userinput {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-left: 0.2rem;
    padding-right: 0.5rem;
  }

  .viewpassword {
    width: 0.48rem;
    height: 0.48rem;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .loginbtn {
    width: 6.54rem;
    margin-top: 0.8rem !important;
  }
  .goodsList{
    background: #f8f8f8;
  }
</style>



// WEBPACK FOOTER //
// src/view/verification.vue